/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { VitalScoreStrictHttpResponse } from '../../vital-score-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LearnWorldEntryResponseModel } from '../../models/learn-world-entry-response-model';

export interface LearnWorldEntryGet$Params {
}

export function learnWorldEntryGet(http: HttpClient, rootUrl: string, params?: LearnWorldEntryGet$Params, context?: HttpContext): Observable<VitalScoreStrictHttpResponse<LearnWorldEntryResponseModel>> {
  const rb = new RequestBuilder(rootUrl, learnWorldEntryGet.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as VitalScoreStrictHttpResponse<LearnWorldEntryResponseModel>;
    })
  );
}

learnWorldEntryGet.PATH = '/LearnWorld/Entry';
